module.exports = __webpack_public_path__ + "media/images/powerpoint/media/questionnaire-52a4bf04e490364f93bb84ad2b8b6581.png";